import { mapGetters } from "vuex";

import comboComponent from "@/components/child/form/combo.vue";
import dateTimePickerComponent from "@/components/child/form/datetimepicker.vue";
import decimalComponent from "@/components/child/form/decimal.vue";
import textareaComponent from "@/components/child/form/textarea.vue";
import searchComboComponent from "@/components/child/searchCombo/search.vue";
import UploadAnexoComponent from "@/components/child/uploadAnexo/uploadAnexo";
import uploadAnexoComponent from "@/components/child/uploadAnexo/uploadAnexo.vue";
import { Component, Watch } from "@/decorators";
import CategoriaControleReclamacaoModel from "@/models/categoriaControleReclamacaoModel";
import ControleReclamacaoModel from "@/models/controleReclamacaoModel";
import ControleReclamacaoStatus from "@/models/enum/controleReclamacaoStatus";
import ControleReclamacaoTipo from "@/models/enum/controleReclamacaoTipo";
import EnumExtensions from "@/models/enum/extensions/enumExtensions";
import FornecedorModel from "@/models/fornecedorModel";
import JustificativaControleReclamacaoModel from "@/models/justificativaControleReclamacaoModel";
import PaginationModel from "@/models/paginationModel";
import ProdutoLoteModel from "@/models/produtoLoteModel";
import VendaModel from "@/models/vendaModel";
import CategoriaControleReclamacaoService from "@/services/categoriaControleReclamacaoService";
import ClienteService from "@/services/clienteService";
import ControleReclamacaoService from "@/services/controleReclamacaoService";
import FornecedorService from "@/services/fornecedorService";
import JustificativaControleReclamacaoService from "@/services/justificativaControleReclamacaoService";
import produtoService from "@/services/produto/produtoService";
import ProdutoLoteService from "@/services/produtoLoteService";
import VendaService from "@/services/vendaService";
import { SessionActions } from "@/store/sessionStore";
import { Getters } from "@/store/store";
import { getClienteCombo, getProdutoLoteCombo, getProdutoLoteComboText } from "@/utils/common/combo/combotext";
import Delay from "@/utils/common/delay";

import EditComponentBase from "../editComponentBase";

@Component({
    components: {
        textareaComponent,
        dateTimePickerComponent,
        uploadAnexoComponent,
        decimalComponent,
        searchComboComponent,
        comboComponent,
    },
    computed: {
        ...mapGetters(["GET_IS_FRACIONAMENTO", "GET_IS_ESTEREIS"] as Getters),
    },
})
export default class ControleReclamacaoEditComponent extends EditComponentBase<ControleReclamacaoModel> {
    // State computed props
    GET_IS_FRACIONAMENTO: () => Promise<boolean>;
    GET_IS_ESTEREIS: () => Promise<boolean>;

    private vendaService = new VendaService();
    private clienteService = new ClienteService();
    private uploadAnexoComponent: UploadAnexoComponent = null;

    isFracionamento = false;
    isEstereis = false;

    produtoLoteOptions: Array<Object> = [];
    produtosOptions: Array<Object> = [];
    fornecedoresOptions: Array<Object> = [];

    showDataLote = false;

    dataFabricacao: Date = new Date();
    dataValidade: Date = new Date();

    private customComboTextCliente = getClienteCombo;

    controleReclamacaoTipoOptions: Array<Object> =
        EnumExtensions.getNamesAndValuesOrderedByValues(ControleReclamacaoTipo);

    statusOtions: Array<Object> = [
        { text: "Aberto", value: ControleReclamacaoStatus.Aberto },
        { text: "Processo", value: ControleReclamacaoStatus.Processo },
        { text: "Finalizado", value: ControleReclamacaoStatus.Finalizado },
    ];

    pessoaOtions: Array<Object> = [
        { text: "Fornecedor", value: 1 },
        { text: "Cliente", value: 2 },
    ];

    categoriaReclamacaoOptions: Array<Object> = [];
    justificativaReclamacaoOptions: Array<Object> = [];

    private clear() {
        this.model = new ControleReclamacaoModel();
    }

    private async onChangeVendaCodigo() {
        if (this.model.vendaCodigo) {
            try {
                const venda = await this.vendaService
                    .getByCodigo(this.model.vendaCodigo)
                    .withLoading()
                    .resolveWithJSON<VendaModel>();

                this.model.clienteNome = venda.clienteNome;
                this.model.atendente = venda.nomeVendedor;
                this.model.clienteId = venda.clienteId;
                this.model.vendaId = venda.id;
            } catch {}
        }
    }

    private async onShowUploadAnexo() {
        while (!this.$refs.uploadAnexoComponent) await Delay(50);
        this.uploadAnexoComponent = this.$refs.uploadAnexoComponent as UploadAnexoComponent;
        this.uploadAnexoComponent.show();
    }

    public async onSucessoSave(id?: number) {
        while (!this.$refs.uploadAnexoComponent) await Delay(50);
        this.uploadAnexoComponent = this.$refs.uploadAnexoComponent as UploadAnexoComponent;
        this.uploadAnexoComponent.onSucessoSave(id);
    }

    @Watch("model.produtoId")
    private async onIdProdutoChanged() {
        try {
            const data = await new ProdutoLoteService()
                .getByProdutoId(this.model.produtoId)
                .withLoading()
                .resolveWithJSON<PaginationModel<ProdutoLoteModel>>();

            const exibeCodigo = this.isFracionamento || this.isEstereis;
            this.produtoLoteOptions = data.list.map(item => ({
                ...getProdutoLoteCombo(item, exibeCodigo),
                text: getProdutoLoteComboText(item, exibeCodigo, item.fornecedorNome),
                fornecedorId: item.fornecedorId ?? null,
                dataFabricacao: item.dataFabricacao,
                dataValidade: item.dataValidade,
            }));
        } catch {}
    }

    @Watch("model.produtoLoteId")
    private async onChangeProdutoLote() {
        if (this.model.produtoLoteId > 0) {
            const data = await new ProdutoLoteService()
                .get(this.model.produtoLoteId)
                .resolveWithJSON<ProdutoLoteModel>()
                .withLoading();

            this.dataFabricacao = data.dataFabricacao;
            this.dataValidade = data.dataValidade;

            if (this.model.fornecedorId == null || this.model.fornecedorId == 0) {
                this.model.fornecedorId = data.fornecedorId;
            }
        }

        this.showDataLote = this.model.produtoLoteId > 0;
    }

    public override async onAfterLoadModel() {
        if (this.model.fornecedorId > 0) {
            this.model.tipoPessoa = 1;
        } else if (this.model.clienteId > 0) {
            this.model.tipoPessoa = 2;
        }

        if (this.model.produtoLoteId > 0) {
            const data = await new ProdutoLoteService()
                .get(this.model.produtoLoteId)
                .resolveWithJSON<ProdutoLoteModel>()
                .withLoading();

            this.dataFabricacao = data.dataFabricacao;
            this.dataValidade = data.dataValidade;
        }
    }

    public override async onPreSave() {
        if (this.model.tipo == 1) {
            this.model.fornecedorId = null;
        } else {
            switch (this.model.tipoPessoa) {
                case 1:
                    this.model.clienteId = null;
                    break;
                case 2:
                    this.model.fornecedorId = null;
                    break;
                default:
                    this.model.clienteId = null;
                    this.model.fornecedorId = null;
                    break;
            }
        }

        return true;
    }

    private async loadCategorias() {
        try {
            const data = await new CategoriaControleReclamacaoService()
                .combo()
                .withLoading()
                .resolveWithJSON<PaginationModel<CategoriaControleReclamacaoModel>>();
            this.categoriaReclamacaoOptions = data.list.map(item => ({
                value: item.id,
                text: item.descricao,
            }));
        } catch {}
    }

    private async loadJustificativas() {
        try {
            const data = await new JustificativaControleReclamacaoService()
                .combo()
                .withLoading()
                .resolveWithJSON<PaginationModel<JustificativaControleReclamacaoModel>>();
            this.justificativaReclamacaoOptions = data.list.map(item => ({
                value: item.id,
                text: item.descricao,
            }));
        } catch {}
    }

    private async loadFornecedores() {
        try {
            const fornecedores = await new FornecedorService()
                .combo()
                .withLoading()
                .resolveWithJSON<PaginationModel<FornecedorModel>>();

            this.fornecedoresOptions = fornecedores.list.map(p => ({
                value: p.id,
                text: p.nome ?? p.nomeFantasia,
            }));
        } catch {}
    }

    private async beforeMount() {
        await this.$store.dispatch(SessionActions.LOAD_USUARIO_LOGADO);
        this.isFracionamento = await this.GET_IS_FRACIONAMENTO();
        this.isEstereis = await this.GET_IS_ESTEREIS();
        await this.setProps(
            new ControleReclamacaoService(),
            "controle-reclamacao",
            new ControleReclamacaoModel(),
        ).withLoading();

        const response = await Promise.all([
            produtoService.comboCached(this.usuarioLogado.franquiaId),
            this.loadCategorias(),
            this.loadJustificativas(),
            this.loadFornecedores(),
        ]).withLoading();

        this.produtosOptions = response[0];
    }
}
